import './App.css'
import './styles/theme.css'
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { AppRoutes } from './components/routing/AppRoutes';
import { ErrorBoundary } from './components/shared/ErrorBoundary';
import { Toaster } from 'react-hot-toast';
import './i18n/config';
import { useEffect } from 'react';
import { useAuthStore } from './store/useAuthStore';
import { MotionConfig } from 'framer-motion';

export function App() {
  const { initializeAuthListener } = useAuthStore();

  useEffect(() => {
    // Initialize auth listener once
    const unsubscribe = initializeAuthListener();
    
    // Cleanup on unmount
    return () => {
      if (typeof unsubscribe === 'function') {
        unsubscribe();
      }
    };
  }, [initializeAuthListener]);

  return (
    <ErrorBoundary>
      <ThemeProvider>
        <MotionConfig reducedMotion="user">
          <BrowserRouter>
            <Toaster position="top-right" />
            <AppRoutes />
          </BrowserRouter>
        </MotionConfig>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
